module.exports = __webpack_public_path__ + "static/Code Review-0e6a75da87350998162a8c5c5349a176.png";